export const onGetButtonMethod = (url, target, history) => {
    if (target && target !== '_self') {
        window.open(url, target);
    } else {
        history.push(url);
    }
};